import { TableWithStoredSettingsAndLayoutSettings } from '@Components/Tables/TableWithStoredSettingsAndLayoutSettings';
import { PERMISSIONS_API } from '@Constants/backendConstants';
import { Permission } from '@Constants/Permission.g';
import { groupColumns } from '@Constants/TableColumns';
import { useHasPermission } from '@Contexts/appContext';
import type { ApiGroup } from '@Model';
import { EnumFrontendLayoutSetting } from '@Model';
import { useListApi } from '@Hooks/useListApi';
import { GroupsRepository } from '@Repositories/Permissions';

export function FrameListGroup() {
    const hasPermission = useHasPermission();

    const module = useListApi(GroupsRepository, PERMISSIONS_API);

    return (
        <TableWithStoredSettingsAndLayoutSettings<ApiGroup>
            layoutSettingsContext={EnumFrontendLayoutSetting.GroupsTableLayout}
            name="GroupList"
            columns={groupColumns}
            loader={module.loadPage}
            canCreate={hasPermission(Permission.PermissionsGroupsCreate)}
            useOnClickNavigation
            fullSize
        />
    );
}
